import { registerClocksSub } from '@/events/services/clocks';
import reframe from 'nike-re-framejs';

registerClocksSub('scoreboard.clock', ['scoreboard', 'clock']);

reframe.registerSub('scoreboard.event', (rx, [_, eventId]) => {
    return reframe.indexPath(['scoreboard', 'events', eventId.toString()]);
});

reframe.registerSub('nikeoneScoreboard.event', (rx, [_, eventId]) => {
    return reframe.indexPath(['nikeone', 'live', eventId, 'match']);
});

reframe.registerSub('topbets.event', (rx, [_, eventId]) => {
    return reframe.indexPath(['topBets', 'betslip', 'events', eventId]);
});
